module.exports = __webpack_public_path__ + "img/1.f9743fa0.png";